import MHero from './MHero.vue';

MHero.install = (app) => {
  app.component('MHero', MHero);
};

export { MHero };
